export enum AlertTypes {
  Success = 'alert-success',
  Error = 'alert-error',
  Initial = ''
}

export interface Alert {
  type: AlertTypes;
  message: string;
}

export const enum AlertActionTypes {
  SHOW_ALERT = '[alert]SHOW_ALERT',
  HIDE_ALERT = '[alert]HIDE_ALERT'
}

export interface AlertState {
  readonly type: AlertTypes;
  readonly message: string;
  readonly visible: boolean;
}



// WEBPACK FOOTER //
// ./src/store/alert/types.ts